// utils/API.js
import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_API_URI+"/api/",
  responseType: "json"
});